export default __webpack_public_path__ + "9edf5a86fe0873b75d0831ff0fee9f3d.jpg";